export default __webpack_public_path__ + "static/CircularStd-BoldItalic-4c56e210d1ce4671d458e868869e40f4.ttf";